import { render, staticRenderFns } from "./articleSegments.vue?vue&type=template&id=49726562"
import script from "./articleSegments.vue?vue&type=script&lang=js"
export * from "./articleSegments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports